import getLocal from '@/app/utils/i18n';

export const getImgUrl = (obj: any) => {
    const { locale } = getLocal();
    return obj[locale] ?? {};
};
